

function pageInit() {

	$(".blog-user-navbar").on("click", function(e) {
		if(!$(this).hasClass("active")) {
			$(this).addClass("active");
		} else {
			$(this).removeClass("active");
		}
		e.stopPropagation();
	});
	$(document).on("click", function(e) {
		if($(".blog-user-navbar").hasClass("active")) {
			$(".blog-user-navbar").removeClass("active");
		}
	});
	$(".blog-aside-navbar").show();

	localStorage.setItem("LastPage", window.location.href);

};

function getDate() {
	var inDate = document.querySelector('.now-date').innerHTML;
	var date = new Date(inDate);
	date.setSeconds(date.getSeconds() + 1);
	document.querySelector('.now-date').innerHTML = date.Format("yyyy-MM-dd hh:mm:ss");
};

window.onload = function() {
	if(isMobile) {
		var panel = document.createElement('div');
		var overlap = document.createElement('div');
		overlap.className = 'panel-overlap';
		panel.className = 'panel-left';
		var menu = document.createElement('div');
		menu.className = 'panel-menu';
		var menuHTML = document.querySelector('.blog-header-menu').innerHTML;
		menu.innerHTML = menuHTML;
		panel.appendChild(menu);
		document.body.appendChild(overlap);
		document.body.appendChild(panel);
		var nav = document.querySelector('.mobile-navs');
		nav.addEventListener('click', function() {
			document.body.classList.add('panel-open');
		});
		overlap.addEventListener('click', function() {
			document.body.classList.remove('panel-open');
		});
		panel.querySelector('.soga-ui').href = 'https://laixiazheteng.cn/app';
	}
};
$(function() {
	$("body").on('copy', function(e) {
		if(typeof window.getSelection == "undefined") return; //IE8 or earlier...

		var body_element = document.getElementsByTagName('body')[0];
		var selection = window.getSelection();

		//if the selection is short let's not annoy our users
		if(("" + selection).length < 30) return;

		//create a div outside of the visible area
		//and fill it with the selected text
		var newdiv = document.createElement('div');
		newdiv.style.position = 'absolute';
		newdiv.style.left = '-99999px';
		body_element.appendChild(newdiv);
		newdiv.appendChild(selection.getRangeAt(0).cloneContents());

		//we need a <pre> tag workaround
		//otherwise the text inside "pre" loses all the line breaks!
		if(selection.getRangeAt(0).commonAncestorContainer.nodeName == "PRE") {
			newdiv.innerHTML = "<pre>" + newdiv.innerHTML + "</pre>";
		};

		newdiv.innerHTML += "著作权归作者所有。<br />商业转载请联系作者获得授权,非商业转载请注明出处。<br />原文: <a href='" +
			document.location.href + "'>" +
			document.location.href + "</a> &copy; <a href='//laixiazheteng.cn/'>laixiazheteng.cn</a>";

		selection.selectAllChildren(newdiv);
		window.setTimeout(function() {
			body_element.removeChild(newdiv);
		}, 200);
	});
	$('.cur-date').text(new Date().getFullYear());
	pageInit();
	var motto = ['Don\'t repeat yourself!',
		'只有尝试后，你才知道是甜是苦..',
		'不懂的知识就努力去补充，这才是成长之道！',
		'我是菜鸟，展翅翱翔是我永恒的主题！',
		'每天用2个小时看看书，未来更美好！',
		'人生最可怕的事情是停止思考！',
		'只要理解原理逻辑，就可以有无穷变化!',
		'人没有最高度，只有新高度！',
		'我是谁，这不重要！',
		'光看不练是退步！',
		'少说话，多思考，人生更美好！'
	];
	var random = Math.floor(Math.random() * motto.length);
	$(".user-motto").text(motto[random]);
	var inDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
	if(document.querySelector('.now-date') != null) {
		document.querySelector('.now-date').innerHTML = inDate;
		setInterval(getDate, 1000);
	};

	var sources = [];
	for(var i = 1; i < 29; i++) {
		var num = i;
		if(i < 10) {
			num = '0' + i;
		}
		var url = "https://imagecloud.laixiazheteng.cn/t_nw" + num + ".jpg";
		sources.push(url);
	};
	sources.sort(function() {
		return Math.random() > 0.5 ? -1 : 1;
	});
	var nSlide = new NSlide("#nslide", {
		width: window.innerWidth * 0.22,
		height: window.innerHeight,
		sources: sources
	});
	$(".blog-aside-navbar").on("mouseover", function() {
		nSlide.flip();
	});
	$(window).on("scroll", utils.scroll.scrollEvent);

	$(".blog-gotop").on("click", utils.scroll.scrollTo);
	$(document).on("mouseover", ".blog-aside-bottom a", function() {
		var top = $(this).offset().top + 3 - $(window).scrollTop();
		var title = $(this).attr("data-title");
		$(".blog-grumble").css({
			"top": top + "px"
		}).text(title).show();
	}).on("mouseout", function() {
		$(".blog-grumble").hide();
	});
	$(".blog-search-container .blog-container-tab ul li").on("click", function(event) {
		var index = $(this).index();
		utils.ripple(event, $(this));
		if(!$(this).hasClass("active")) {
			$(this).addClass("active").siblings().removeClass("active");
			$(".blog-search-container .blog-article-con").hide();
			$(".blog-search-container .blog-article-con").eq(index).show();
		}
	});
	$(".blog-search-input").on("focus", utils.input.searchInputFocus).on("blur", utils.input.searchInputBlur);

	$(".blog-search").on("click", function() {
		$(".blog-search-board").addClass("active");
	});
	$(".blog-find").on("click", utils.search.click);
	$(".blog-search-close").on("click", utils.search.close);
	$(window).on("keydown", function(e) {
		var searchInput = document.querySelector(".blog-search-input");
		if(e.keyCode == 13 && searchInput == document.activeElement) {
			utils.search.click();
		}
	});
	$(document).on("click", ".blog-search-list li", utils.search.itemClick);
	$(".blog-model-register").on("click", function() {
		$(".ww_model_inner").css("transform", "rotateY(180deg)");
	});

	console.log('%c交流群：481231348(新群，人烟稀少，目前数量一目了然)', 'font-size:25px;color:#009a61;');
	//	setInterval(function(){
	//		if(!document.hasFocus()){
	//			document.title='TG-喂，你在干嘛!';
	//		}else{
	//			document.title='TG--敢于尝试，无所畏惧';
	//		}
	//	},1000);
});